import { render, staticRenderFns } from "./Assessments.vue?vue&type=template&id=37fe5400&scoped=true"
import script from "./Assessments.vue?vue&type=script&lang=js"
export * from "./Assessments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe5400",
  null
  
)

export default component.exports